import attachFilesForSelectedAction from './helpers/attachFilesForSelectedAction';
import createFilePickerUserConfiguration from './helpers/configuration/createFilePickerUserConfiguration';
import { CreateAttachmentHandler } from '../types/CreateAttachmentHandler';
import {
    FilePickerUserConfiguration,
    FileProviderItemType,
    FileProviderItemViewState,
    lazyActionsPanel,
    SelectedFilesSource,
} from 'owa-filepicker';
import { FileProviderType } from 'owa-fileprovider-store';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { trace } from 'owa-trace';

export default async function attachmentActionsPanel(
    createAttachmentHandler: CreateAttachmentHandler,
    files: File[] | FileProviderItemViewState[],
    selectedFileProviderType: null,
    selectedFileSource: SelectedFilesSource.LocalComputerFiles,
    maxClassicAttachmentSize: number
): Promise<void>;
export default async function attachmentActionsPanel(
    createAttachmentHandler: CreateAttachmentHandler,
    files: File[] | FileProviderItemViewState[],
    selectedFileProviderType: AttachmentDataProviderType,
    selectedFileSource: SelectedFilesSource.ProviderFiles,
    maxClassicAttachmentSize: number
): Promise<void>;
export default async function attachmentActionsPanel(
    createAttachmentHandler: CreateAttachmentHandler,
    files: File[] | FileProviderItemViewState[],
    selectedFileProviderType: FileProviderType | null,
    selectedFileSource: SelectedFilesSource,
    maxClassicAttachmentSize: number
): Promise<void> {
    const actionsPanel = await lazyActionsPanel.import();
    const filePickerUserConfiguration: FilePickerUserConfiguration = createFilePickerUserConfiguration();

    try {
        if (!files || files.length == 0) {
            throw new Error('files length cannot be 0.');
        }
        return actionsPanel(
            files,
            maxClassicAttachmentSize,
            selectedFileProviderType,
            files[0].type === FileProviderItemType.Group,
            files.length > 1,
            selectedFileSource,
            filePickerUserConfiguration
        )
            .then(action => {
                attachFilesForSelectedAction(
                    createAttachmentHandler,
                    files,
                    selectedFileSource,
                    action
                );
            })
            .catch(() => {
                // No action was selected
            });
    } catch (error) {
        trace.error(
            `Error creating the action panel. Attaching or sharing files might not work! ${error}`
        );
    }
}
